<template>
    <div>
        <ModalImpressao ref="modal" @acao="imprimirGuia" header="Impressão das Guias">
            <div v-if="guias_visualizacao">
                <div v-for="(guia, index) in guias_visualizacao" :key="index">
                    <div
                        v-if="guia.nome == 'Consulta' && guia.ch_status != 'CA'"
                        style="width: 210mm; height: 297mm;"
                    >
                        <guia-de-consulta
                            :guia="guia"
                            :logo="logo_url"
                            :operadora="marcacao.plano.operadora"
                            :nome_contratado_ass="nome_contratado_ass"
                            :pageIndex="index + 1"
                            :pageCount="guias_visualizacao.length"
                            class="mx-auto"
                            style="width:320mm;"
                        >
                        </guia-de-consulta>
                    </div>

                    <div
                        v-if="guia.nome == 'SP/SADT' && guia.ch_status != 'CA'"
                        style="page-break-before: always; page-break-after: always;"
                    >
                        <guia-spsadt
                            :guia="guia"
                            :logo="logo_url"
                            :operadora="marcacao.plano.operadora"
                            :nome_contratado_ass="nome_contratado_ass"
                            :pageIndex="index + 1"
                            :pageCount="guias_visualizacao.length"
                            :primeira_pagina="primeira_pagina"
                            :eh_primeira_pagina="teste_primeira_pagina(guia, index)"
                            :marcacao="marcacao"
                            nomeGuia="guiaSP-SADT"
                            xstyle="-webkit-transform:scale(0.55, 0.55);position:relative;top:-9.5cm;left:-7.2cm;!important;"
                        ></guia-spsadt>
                    </div>

                    <!-- Outras despesas -->
                    <div
                        v-if="
                            !primeira_pagina &&
                                guia.nome == 'SP/SADT' &&
                                guia.ch_status != 'CA' &&
                                guia.mensagemTISS &&
                                guia.mensagemTISS.prestadorParaOperadora &&
                                guia.mensagemTISS.prestadorParaOperadora
                                    .loteGuias.guiasTISS['guiaSP-SADT']
                                    .outrasDespesas &&
                                Array.isArray(
                                    guia.mensagemTISS.prestadorParaOperadora
                                        .loteGuias.guiasTISS['guiaSP-SADT']
                                        .outrasDespesas.despesa
                                ) &&
                                Array.isArray(
                                    guia.mensagemTISS.prestadorParaOperadora
                                        .loteGuias.guiasTISS['guiaSP-SADT']
                                        .outrasDespesas.despesa[0]
                                )
                        "
                        style="page-break-before: always; page-break-after: always;"
                    >
                        <template
                            v-for="(despesas, idxDesp) in guia.mensagemTISS
                                .prestadorParaOperadora.loteGuias.guiasTISS[
                                'guiaSP-SADT'
                            ].outrasDespesas.despesa"
                        >
                            <guia-outras-despesas
                                :key="idxDesp"
                                :guia="guia"
                                :logo="logo_url"
                                :operadora="marcacao.plano.operadora"
                                :outrasDespesas="despesas"
                                nomeGuia="guiaSP-SADT"
                                xstyle="-webkit-transform:scale(0.55, 0.55);position:relative;top:-9.5cm;left:-7.2cm;!important;"
                            ></guia-outras-despesas>
                        </template>
                    </div>

                    <div
                        v-if="
                            guia.nome == 'Honorário Individual' &&
                                guia.ch_status != 'CA'
                        "
                    >
                        <guia-honorarios
                            :guia="guia"
                            :operadora="marcacao.plano.operadora"
                            :logo="logo_url"
                            :pageIndex="index + 1"
                            :pageCount="guias_visualizacao.length"
                            xstyle="-webkit-transform:scale(0.55, 0.55);position:relative;top:-9.5cm;left:-7.2cm;!important;"
                        ></guia-honorarios>
                    </div>

                     <div
                        v-if="
                            guia.nome == 'Tratamento Odontológico' &&
                                guia.ch_status != 'CA'
                        "
                        style="page-break-before: always; page-break-after: always;"
                    >
                        <guia-odonto
                            :guia="guia"
                            :logo="logo_url"
                            :operadora="marcacao.plano.operadora"
                            :nome_contratado_ass="nome_contratado_ass"
                            :pageIndex="index + 1"
                            :pageCount="guias_visualizacao.length"
                            xstyle="-webkit-transform:scale(0.55, 0.55);position:relative;top:-9.5cm;left:-7.2cm;!important;"
                        ></guia-odonto>
                    </div>

                    <div
                        v-if="
                            guia.nome == 'Resumo de Internação' &&
                                guia.ch_status != 'CA'
                        "
                        style="page-break-before: always; page-break-after: always;"
                    >
                        <guia-resumo-internacao
                            :guia="guia"
                            :logo="logo_url"
                            :operadora="marcacao.plano.operadora"
                            :nome_contratado_ass="nome_contratado_ass"
                            :pageIndex="index + 1"
                            :pageCount="guias_visualizacao.length"
                            xstyle="-webkit-transform:scale(0.55, 0.55);position:relative;top:-9.5cm;left:-7.2cm;!important;"
                        ></guia-resumo-internacao>
                    </div>

                    <!-- Outras despesas: guiaResumoInternacao -->
                    <div
                        v-if="
                            guia.nome == 'Resumo de Internação' &&
                                guia.ch_status != 'CA' &&
                                guia.mensagemTISS &&
                                guia.mensagemTISS.prestadorParaOperadora &&
                                guia.mensagemTISS.prestadorParaOperadora
                                    .loteGuias.guiasTISS['guiaResumoInternacao']
                                    .outrasDespesas &&
                                Array.isArray(
                                    guia.mensagemTISS.prestadorParaOperadora
                                        .loteGuias.guiasTISS[
                                        'guiaResumoInternacao'
                                    ].outrasDespesas.despesa
                                ) &&
                                Array.isArray(
                                    guia.mensagemTISS.prestadorParaOperadora
                                        .loteGuias.guiasTISS[
                                        'guiaResumoInternacao'
                                    ].outrasDespesas.despesa[0]
                                )
                        "
                        style="page-break-before: always; page-break-after: always;"
                    >
                        <template
                            v-for="(despesas, idxDesp) in guia.mensagemTISS
                                .prestadorParaOperadora.loteGuias.guiasTISS[
                                'guiaResumoInternacao'
                            ].outrasDespesas.despesa"
                        >
                            <guia-outras-despesas
                                :key="idxDesp"
                                :guia="guia"
                                :logo="logo_url"
                                :operadora="marcacao.plano.operadora"
                                :outrasDespesas="despesas"
                                nomeGuia="guiaResumoInternacao"
                                xstyle="-webkit-transform:scale(0.55, 0.55);position:relative;top:-9.5cm;left:-7.2cm;!important;"
                            ></guia-outras-despesas>
                        </template>
                    </div>
                </div>

                <!-- impressao-guiass -->
                <div v-show="false" id="impressao-guiass">
                    <div
                        v-for="(guia, index) in guias_visualizacao"
                        :key="index"
                    >
                        <!-- :style="guia.ch_status != 'CA' ? 'width: 100%; height: 98%;' : ''" -->
                        <template
                            v-if="
                                guia.nome == 'Consulta' &&
                                    guia.ch_status != 'CA'
                            "
                        >
                            <guia-de-consulta
                                :guia="guia"
                                :operadora="marcacao.plano.operadora"
                                :logo="logo_url"
                                :nome_contratado_ass="nome_contratado_ass"
                                class="w-100"
                                :pageIndex="index + 1"
                                :pageCount="guias_visualizacao.length"
                            ></guia-de-consulta>
                        </template>

                        <template
                            v-if="
                                guia.nome == 'SP/SADT' && guia.ch_status != 'CA'
                            "
                        >
                            <guia-spsadt
                                :guia="guia"
                                :operadora="marcacao.plano.operadora"
                                :logo="logo_url"
                                :nome_contratado_ass="nome_contratado_ass"
                                :rotate="true"
                                :pageIndex="index + 1"
                                :pageCount="guias_visualizacao.length"
                                :primeira_pagina="primeira_pagina"
                                :eh_primeira_pagina="teste_primeira_pagina(guia, index)"
                                :marcacao="marcacao"
                            ></guia-spsadt>
                            <!-- <div style="page-break-after: always;">
                                &nbsp;
                            </div> -->
                        </template>

                        <!-- Outras despesas -->
                        <template
                            v-if="
                                guia.nome == 'SP/SADT' &&
                                    guia.ch_status != 'CA' &&
                                    guia.mensagemTISS &&
                                    guia.mensagemTISS.prestadorParaOperadora &&
                                    guia.mensagemTISS.prestadorParaOperadora
                                        .loteGuias.guiasTISS['guiaSP-SADT']
                                        .outrasDespesas &&
                                    Array.isArray(
                                        guia.mensagemTISS.prestadorParaOperadora
                                            .loteGuias.guiasTISS['guiaSP-SADT']
                                            .outrasDespesas.despesa
                                    ) &&
                                    Array.isArray(
                                        guia.mensagemTISS.prestadorParaOperadora
                                            .loteGuias.guiasTISS['guiaSP-SADT']
                                            .outrasDespesas.despesa[0]
                                    )
                            "
                        >
                            <template
                                v-for="(despesas, idxDesp) in guia.mensagemTISS
                                    .prestadorParaOperadora.loteGuias.guiasTISS[
                                    'guiaSP-SADT'
                                ].outrasDespesas.despesa"
                            >
                                <!-- <div  :key="'a' + idxDesp" style="page-break-before: always;">
                                &nbsp;
                                </div> -->
                                <guia-outras-despesas
                                    :key="idxDesp"
                                    :guia="guia"
                                    :operadora="marcacao.plano.operadora"
                                    :logo="logo_url"
                                    :outrasDespesas="despesas"
                                    :rotate="true"
                                    nomeGuia="guiaSP-SADT"
                                ></guia-outras-despesas>
                            </template>
                        </template>

                        <!-- Honorário Individual   -->
                        <template
                            v-if="
                                guia.nome == 'Honorário Individual' &&
                                    guia.ch_status != 'CA'
                            "
                        >
                            <guia-honorarios
                                :guia="guia"
                                :operadora="marcacao.plano.operadora"
                                :logo="logo_url"
                                :rotate="true"
                                :pageIndex="index + 1"
                                :pageCount="guias_visualizacao.length"
                            ></guia-honorarios>
                        </template>

                        <template
                            v-if="
                                guia.nome == 'Tratamento Odontológico' &&
                                    guia.ch_status != 'CA'
                            "
                        >
                            <guia-odonto
                                :guia="guia"
                                :operadora="marcacao.plano.operadora"
                                :logo="logo_url"
                                :nome_contratado_ass="nome_contratado_ass"
                                :rotate="true"
                                :pageIndex="index + 1"
                                :pageCount="guias_visualizacao.length"
                            ></guia-odonto>
                        </template>

                        <template
                            v-if="
                                guia.nome == 'Resumo de Internação' &&
                                    guia.ch_status != 'CA'
                            "
                        >
                            <guia-resumo-internacao
                                :guia="guia"
                                :operadora="marcacao.plano.operadora"
                                :logo="logo_url"
                                :nome_contratado_ass="nome_contratado_ass"
                                :rotate="true"
                                :pageIndex="index + 1"
                                :pageCount="guias_visualizacao.length"
                            ></guia-resumo-internacao>
                        </template>

                        <!-- Outras despesas -->
                        <template
                            v-if="
                                guia.nome == 'Resumo de Internação' &&
                                    guia.ch_status != 'CA' &&
                                    guia.mensagemTISS &&
                                    guia.mensagemTISS.prestadorParaOperadora &&
                                    guia.mensagemTISS.prestadorParaOperadora
                                        .loteGuias.guiasTISS[
                                        'guiaResumoInternacao'
                                    ].outrasDespesas &&
                                    Array.isArray(
                                        guia.mensagemTISS.prestadorParaOperadora
                                            .loteGuias.guiasTISS[
                                            'guiaResumoInternacao'
                                        ].outrasDespesas.despesa
                                    ) &&
                                    Array.isArray(
                                        guia.mensagemTISS.prestadorParaOperadora
                                            .loteGuias.guiasTISS[
                                            'guiaResumoInternacao'
                                        ].outrasDespesas.despesa[0]
                                    )
                            "
                        >
                            <template
                                v-for="(despesas, idxDesp) in guia.mensagemTISS
                                    .prestadorParaOperadora.loteGuias.guiasTISS[
                                    'guiaResumoInternacao'
                                ].outrasDespesas.despesa"
                            >
                                <!-- <div  :key="'a' + idxDesp" style="page-break-before: always;">
                                &nbsp;
                                </div> -->
                                <guia-outras-despesas
                                    :key="idxDesp"
                                    :guia="guia"
                                    :operadora="marcacao.plano.operadora"
                                    :logo="logo_url"
                                    :outrasDespesas="despesas"
                                    :rotate="true"
                                    nomeGuia="guiaResumoInternacao"
                                ></guia-outras-despesas>
                            </template>
                        </template>
                    </div>
                </div>

                <!-- impressao-guias-consulta -->
                <div v-show="false" id="impressao-guiass-consulta">
                    <div
                        v-for="(guia, index) in guias_visualizacao"
                        :key="index"
                        :style="
                            guia.ch_status != 'CA'
                                ? 'width: 100%; height: 98%;'
                                : ''
                        "
                    >
                        <template
                            v-if="
                                guia.nome == 'Consulta' &&
                                    guia.ch_status != 'CA'
                            "
                        >
                            <guia-de-consulta
                                :guia="guia"
                                :operadora="marcacao.plano.operadora"
                                :logo="logo_url"
                                :nome_contratado_ass="nome_contratado_ass"
                                :pageIndex="index + 1"
                                :pageCount="guias_visualizacao.length"
                                class="w-100"
                            ></guia-de-consulta>
                        </template>
                    </div>
                </div>

                <!-- impressao-guiass -->
                <div v-show="false" id="impressao-guiass-sadt">
                    <div
                        v-for="(guia, index) in guias_visualizacao"
                        :key="index"
                    >
                        <!-- :style="guia.ch_status != 'CA' ? 'width: 100%; height: 98%;' : ''" -->

                        <template
                            v-if="
                                guia.nome == 'SP/SADT' && guia.ch_status != 'CA'
                            "
                        >
                            <guia-spsadt
                                :guia="guia"
                                :operadora="marcacao.plano.operadora"
                                :logo="logo_url"
                                :nome_contratado_ass="nome_contratado_ass"
                                :rotate="true"
                                :pageIndex="index + 1"
                                :pageCount="guias_visualizacao.length"
                                :primeira_pagina="primeira_pagina"
                                :eh_primeira_pagina="teste_primeira_pagina(guia, index)"
                                :marcacao="marcacao"
                            ></guia-spsadt>
                        </template>
                        <!-- Outras despesas -->
                        <template
                            v-if="
                                guia.nome == 'SP/SADT' &&
                                    guia.ch_status != 'CA' &&
                                    guia &&
                                    guia.mensagemTISS &&
                                    guia.mensagemTISS.prestadorParaOperadora &&
                                    guia.mensagemTISS.prestadorParaOperadora
                                        .loteGuias.guiasTISS['guiaSP-SADT']
                                        .outrasDespesas &&
                                    Array.isArray(
                                        guia.mensagemTISS.prestadorParaOperadora
                                            .loteGuias.guiasTISS['guiaSP-SADT']
                                            .outrasDespesas.despesa
                                    ) &&
                                    Array.isArray(
                                        guia.mensagemTISS.prestadorParaOperadora
                                            .loteGuias.guiasTISS['guiaSP-SADT']
                                            .outrasDespesas.despesa[0]
                                    )
                            "
                        >
                            <template
                                v-for="(despesas, idxDesp) in guia.mensagemTISS
                                    .prestadorParaOperadora.loteGuias.guiasTISS[
                                    'guiaSP-SADT'
                                ].outrasDespesas.despesa"
                            >
                                <guia-outras-despesas
                                    :key="idxDesp"
                                    :guia="guia"
                                    :operadora="marcacao.plano.operadora"
                                    :logo="logo_url"
                                    :outrasDespesas="despesas"
                                    :rotate="true"
                                    nomeGuia="guiaSP-SADT"
                                ></guia-outras-despesas>
                            </template>
                        </template>

                        <template
                            v-if="
                                guia.nome == 'Honorário Individual' &&
                                    guia.ch_status != 'CA'
                            "
                        >
                            <guia-honorarios
                                :guia="guia"
                                :operadora="marcacao.plano.operadora"
                                :logo="logo_url"
                                :pageIndex="index + 1"
                                :pageCount="guias_visualizacao.length"
                                :rotate="true"
                            ></guia-honorarios>
                        </template>

                        <template
                            v-if="
                                guia.nome == 'Tratamento Odontológico' &&
                                    guia.ch_status != 'CA'
                            "
                        >
                            <guia-odonto
                                :guia="guia"
                                :operadora="marcacao.plano.operadora"
                                :logo="logo_url"
                                :nome_contratado_ass="nome_contratado_ass"
                                :rotate="true"
                                :pageIndex="index + 1"
                                :pageCount="guias_visualizacao.length"
                            ></guia-odonto>
                        </template>

                        <template
                            v-if="
                                guia.nome == 'Resumo de Internação' &&
                                    guia.ch_status != 'CA'
                            "
                        >
                            <guia-resumo-internacao
                                :guia="guia"
                                :operadora="marcacao.plano.operadora"
                                :logo="logo_url"
                                :nome_contratado_ass="nome_contratado_ass"
                                :rotate="true"
                                :pageIndex="index + 1"
                                :pageCount="guias_visualizacao.length"
                            ></guia-resumo-internacao>
                        </template>
                        <!-- Outras despesas -->
                        <template
                            v-if="
                                guia.nome == 'Resumo de Internação' &&
                                    guia.ch_status != 'CA' &&
                                    guia &&
                                    guia.mensagemTISS &&
                                    guia.mensagemTISS.prestadorParaOperadora &&
                                    guia.mensagemTISS.prestadorParaOperadora
                                        .loteGuias.guiasTISS[
                                        'guiaResumoInternacao'
                                    ].outrasDespesas &&
                                    Array.isArray(
                                        guia.mensagemTISS.prestadorParaOperadora
                                            .loteGuias.guiasTISS[
                                            'guiaResumoInternacao'
                                        ].outrasDespesas.despesa
                                    ) &&
                                    Array.isArray(
                                        guia.mensagemTISS.prestadorParaOperadora
                                            .loteGuias.guiasTISS[
                                            'guiaResumoInternacao'
                                        ].outrasDespesas.despesa[0]
                                    )
                            "
                        >
                            <template
                                v-for="(despesas, idxDesp) in guia.mensagemTISS
                                    .prestadorParaOperadora.loteGuias.guiasTISS[
                                    'guiaResumoInternacao'
                                ].outrasDespesas.despesa"
                            >
                                <guia-outras-despesas
                                    :key="idxDesp"
                                    :guia="guia"
                                    :operadora="marcacao.plano.operadora"
                                    :logo="logo_url"
                                    :outrasDespesas="despesas"
                                    :rotate="true"
                                    nomeGuia="guiaResumoInternacao"
                                ></guia-outras-despesas>
                            </template>
                        </template>
                    </div>
                </div>
            </div>
        </ModalImpressao>
    </div>
</template>

<script>
import _ from "lodash";
import GuiaDeConsulta from "./GuiaDeConsulta.vue";
import guiaSpsadt from "./GuiaSPSADT.vue";
import guiaResumoInternacao from "./GuiaResumoInternacao.vue";
import guiaOdonto from "./GuiaOdonto.vue";
import guiaOutrasDespesas from "./GuiaOutrasDespesas.vue";
import GuiaHonorarios from "./GuiaHonorarios.vue";
import ModalImpressao from "../relatorios/shared/ModalImpressao";

export default {
    data() {
        return {
            marcacao_guias: null,
            guias_visualizacao: null,
            primeira_pagina: false, 
            valor_total_geral: false,
        };
    },
    methods: {
        teste_primeira_pagina(guia, index) {
            return this.guias_visualizacao.findIndex(item => item.id_guia == guia.id_guia) === index;
        },
        tipo_guia(guia) {
            if (
                _.get(
                    guia,
                    "mensagemTISS.prestadorParaOperadora.loteGuias.guiasTISS.guiaSP-SADT"
                )
            ) {
                return "SPSADT";
            }
            return "?";
        },

        inicializacao() {
            this.primeira_pagina = false;
            this.valor_total_geral = false;
            
            this.dividirGuiaSpSadt();

            this.$refs.modal.abrirModalImpressao();
        },
        imprimirGuia() {
            const configPrint = {
                styles: [
                    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
                    this.guias_visualizacao.find(
                        item =>
                            item.nome == "SP/SADT" ||
                            item.nome == "Honorário Individual" ||
                            item.nome == "Tratamento Odontológico" ||
                            item.nome == "Resumo de Internação"
                    )
                        ? "https://api.klingo.app/css/estiloa4l.css"
                        : ""
                ]
            };

            this.$htmlToPaper("impressao-guiass", configPrint, () => {});
        },
        imprimirConsulta(idGuia = null) {
            this.dividirGuiaSpSadt("C", idGuia);
            this.$refs.modal.abrirModalImpressao();

            this.$nextTick(() => {
                const configPrint = {
                    styles: [
                        "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css"
                    ]
                };

                this.$htmlToPaper(
                    "impressao-guiass-consulta",
                    configPrint,
                    () => {
                        this.$refs.modal.fechar();
                    }
                );
            });
        },
        imprimirOutras(idGuia = null, primeira_pagina = false, valor_total_geral = false) {
            this.primeira_pagina = primeira_pagina;
            this.valor_total_geral = primeira_pagina && valor_total_geral;

            this.dividirGuiaSpSadt("S", idGuia);
            this.$refs.modal.abrirModalImpressao();

            this.$nextTick(() => {
                const configPrint = {
                    styles: [
                        "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
                        "https://api.klingo.app/css/estiloa4l.css"
                    ]
                };

                //this.$htmlToPaper("impressao-guiass-sadt", configPrint2, () => {});
                this.$htmlToPaper("impressao-guiass-sadt", configPrint, () => {
                    this.$refs.modal.fechar();
                });
            });
        },

        dividirGuiaSpSadt(tipo = null, idGuia = null) {
            if (tipo == null) {
                this.marcacao_guias = _.cloneDeep(this.guias);
                this.guias_visualizacao = _.cloneDeep(this.guias);
            } else {
                this.marcacao_guias = _.cloneDeep(this.guias);
                this.guias_visualizacao = _.cloneDeep(this.guias);

                if ( this.valor_total_geral ) { 
                    let total = this.guias_visualizacao.reduce((total, carry) => {
                        return total + parseFloat(_.get(carry, 'mensagemTISS.prestadorParaOperadora.loteGuias.guiasTISS.guiaSP-SADT.valorTotal.valorTotalGeral', 0));
                    }, 0);

                    this.guias_visualizacao = this.guias_visualizacao.map(item => { 
                        _.set(item, 'mensagemTISS.prestadorParaOperadora.loteGuias.guiasTISS.guiaSP-SADT.valorTotal.valorTotalGeral', total);
                        return item;
                    });
                }

                let arrayGuias = [];
                let guiasVis = [];

                for (
                    let index = 0;
                    index < this.marcacao_guias.length;
                    index++
                ) {
                    if (
                        this.marcacao_guias[index] && 
                        ( 
                            (tipo == "C" &&
                                this.marcacao_guias[index].nome == "Consulta") ||
                            (tipo == "S" &&
                                this.marcacao_guias[index].nome != "Consulta")
                        )
                    ) {
                        if (
                            idGuia == null ||
                            this.marcacao_guias[index].id_guia == idGuia
                        ) {
                            arrayGuias.push(
                                _.cloneDeep(this.marcacao_guias[index])
                            );
                            guiasVis.push(
                                _.cloneDeep(this.guias_visualizacao[index])
                            );
                        }
                    }
                }

                this.marcacao_guias = _.cloneDeep(arrayGuias);
                this.guias_visualizacao = _.cloneDeep(guiasVis);
            }

            for (let index = 0; index < this.marcacao_guias.length; index++) {
                const guiaAtendimento = this.marcacao_guias[index];
                const guia = this.guias_visualizacao[index];

                if (!guia) {
                    continue;
                }

                if (
                    guiaAtendimento.ch_status != "CA" &&
                    guiaAtendimento.nome == "SP/SADT"
                ) {
                    // Verifica se a quantidade de procedimento é maior do que 5
                    if (
                        guia.mensagemTISS.prestadorParaOperadora.loteGuias
                                .guiasTISS["guiaSP-SADT"]
                                .procedimentosExecutados
                        &&
                        Array.isArray(
                            guia.mensagemTISS.prestadorParaOperadora.loteGuias
                                .guiasTISS["guiaSP-SADT"]
                                .procedimentosExecutados.procedimentoExecutado
                        ) &&
                        guia.mensagemTISS.prestadorParaOperadora.loteGuias
                            .guiasTISS["guiaSP-SADT"].procedimentosExecutados
                            .procedimentoExecutado.length > 5
                    ) {
                        // Divide os procedimentos da guia
                        var procedimentos = this.guias_visualizacao[
                            index
                        ].mensagemTISS.prestadorParaOperadora.loteGuias.guiasTISS[
                            "guiaSP-SADT"
                        ].procedimentosExecutados.procedimentoExecutado.splice(
                            5
                        );

                        // Clona a guia e atribui os procedimentos removidos da anterior
                        const novaGuia = _.cloneDeep(
                            this.guias_visualizacao[index]
                        );
                        novaGuia.mensagemTISS.prestadorParaOperadora.loteGuias.guiasTISS[
                            "guiaSP-SADT"
                        ].procedimentosExecutados.procedimentoExecutado = procedimentos;

                        // Remover outras despesas da guia corrente e deixa na nova
                        delete this.guias_visualizacao[index].mensagemTISS
                            .prestadorParaOperadora.loteGuias.guiasTISS[
                            "guiaSP-SADT"
                        ].outrasDespesas;

                        this.marcacao_guias.push(guiaAtendimento);
                        this.guias_visualizacao.push(novaGuia);
                    }

                    // Dividir outras despesas
                    if (
                        this.guias_visualizacao[index].mensagemTISS
                            .prestadorParaOperadora.loteGuias.guiasTISS[
                            "guiaSP-SADT"
                        ].outrasDespesas &&
                        this.guias_visualizacao[index].mensagemTISS
                            .prestadorParaOperadora.loteGuias.guiasTISS[
                            "guiaSP-SADT"
                        ].outrasDespesas.despesa
                    ) {
                        // Se tiver só 1 material/med, converter para array
                        if (
                            !Array.isArray(
                                this.guias_visualizacao[index].mensagemTISS
                                    .prestadorParaOperadora.loteGuias.guiasTISS[
                                    "guiaSP-SADT"
                                ].outrasDespesas.despesa
                            )
                        ) {
                            this.guias_visualizacao[
                                index
                            ].mensagemTISS.prestadorParaOperadora.loteGuias.guiasTISS[
                                "guiaSP-SADT"
                            ].outrasDespesas.despesa = [
                                _.cloneDeep(
                                    this.guias_visualizacao[index].mensagemTISS
                                        .prestadorParaOperadora.loteGuias
                                        .guiasTISS["guiaSP-SADT"].outrasDespesas
                                        .despesa
                                )
                            ];
                        }

                        var limiteDespesas = _.cloneDeep(
                            _.orderBy(
                                this.guias_visualizacao[index].mensagemTISS
                                    .prestadorParaOperadora.loteGuias.guiasTISS[
                                    "guiaSP-SADT"
                                ].outrasDespesas.despesa,
                                "descricaoProcedimento"
                            )
                        );

                        let arrayOutrasDespesas = [];

                        while (limiteDespesas.length > 0) {
                            var restoDespesas = limiteDespesas.splice(10);

                            arrayOutrasDespesas.push(
                                _.cloneDeep(
                                    _.orderBy(
                                        limiteDespesas,
                                        "descricaoProcedimento"
                                    )
                                )
                            );

                            limiteDespesas = _.cloneDeep(restoDespesas);
                        }

                        // Subistituir o array de outras despesas por um array de arrays
                        this.guias_visualizacao[
                            index
                        ].mensagemTISS.prestadorParaOperadora.loteGuias.guiasTISS[
                            "guiaSP-SADT"
                        ].outrasDespesas.despesa = arrayOutrasDespesas;
                    }
                } else if (
                    guiaAtendimento.ch_status != "CA" &&
                    guiaAtendimento.nome == "Honorário Individual"
                ) {
                    if (
                        Array.isArray(
                            guia.mensagemTISS.prestadorParaOperadora.loteGuias
                                .guiasTISS["guiaHonorarios"]
                                .procedimentosRealizados.procedimentoRealizado
                        ) &&
                        guia.mensagemTISS.prestadorParaOperadora.loteGuias
                            .guiasTISS["guiaHonorarios"].procedimentosRealizados
                            .procedimentoRealizado.length > 5
                    ) {
                        // Divide os procedimentos da guia
                        var procedimentosRealizados = this.guias_visualizacao[
                            index
                        ].mensagemTISS.prestadorParaOperadora.loteGuias.guiasTISS[
                            "guiaHonorarios"
                        ].procedimentosRealizados.procedimentoRealizado.splice(
                            5
                        );

                        // Clona a guia e atribui os procedimentos removidos da anterior
                        const novaGuia = _.cloneDeep(
                            this.guias_visualizacao[index]
                        );
                        novaGuia.mensagemTISS.prestadorParaOperadora.loteGuias.guiasTISS[
                            "guiaHonorarios"
                        ].procedimentosRealizados.procedimentoRealizado = procedimentosRealizados;

                        this.marcacao_guias.push(guiaAtendimento);
                        this.guias_visualizacao.push(novaGuia);
                    }
                } else if (
                    guiaAtendimento.ch_status != "CA" &&
                    guiaAtendimento.nome == "Resumo de Internação"
                ) {
                    // Verifica se a quantidade de procedimento é maior do que 5
                    if (
                        guia.mensagemTISS.prestadorParaOperadora.loteGuias
                            .guiasTISS["guiaResumoInternacao"]
                            .procedimentosExecutados
                        &&
                        Array.isArray(
                            guia.mensagemTISS.prestadorParaOperadora.loteGuias
                                .guiasTISS["guiaResumoInternacao"]
                                .procedimentosExecutados.procedimentoExecutado
                        ) &&
                        guia.mensagemTISS.prestadorParaOperadora.loteGuias
                            .guiasTISS["guiaResumoInternacao"]
                            .procedimentosExecutados.procedimentoExecutado
                            .length > 5
                    ) {
                        // Divide os procedimentos da guia
                        var procedimentosResumo = this.guias_visualizacao[
                            index
                        ].mensagemTISS.prestadorParaOperadora.loteGuias.guiasTISS[
                            "guiaResumoInternacao"
                        ].procedimentosExecutados.procedimentoExecutado.splice(
                            5
                        );

                        // Clona a guia e atribui os procedimentos removidos da anterior
                        const novaGuia = _.cloneDeep(
                            this.guias_visualizacao[index]
                        );
                        novaGuia.mensagemTISS.prestadorParaOperadora.loteGuias.guiasTISS[
                            "guiaResumoInternacao"
                        ].procedimentosExecutados.procedimentoExecutado = procedimentosResumo;

                        // Remover outras despesas da guia corrente e deixa na nova
                        delete this.guias_visualizacao[index].mensagemTISS
                            .prestadorParaOperadora.loteGuias.guiasTISS[
                            "guiaResumoInternacao"
                        ].outrasDespesas;

                        this.marcacao_guias.push(guiaAtendimento);
                        this.guias_visualizacao.push(novaGuia);
                    }

                    // Dividir outras despesas
                    if (
                        this.guias_visualizacao[index].mensagemTISS
                            .prestadorParaOperadora.loteGuias.guiasTISS[
                            "guiaResumoInternacao"
                        ].outrasDespesas &&
                        this.guias_visualizacao[index].mensagemTISS
                            .prestadorParaOperadora.loteGuias.guiasTISS[
                            "guiaResumoInternacao"
                        ].outrasDespesas.despesa
                    ) {
                        // Se tiver só 1 material/med, converter para array
                        if (
                            !Array.isArray(
                                this.guias_visualizacao[index].mensagemTISS
                                    .prestadorParaOperadora.loteGuias.guiasTISS[
                                    "guiaResumoInternacao"
                                ].outrasDespesas.despesa
                            )
                        ) {
                            this.guias_visualizacao[
                                index
                            ].mensagemTISS.prestadorParaOperadora.loteGuias.guiasTISS[
                                "guiaResumoInternacao"
                            ].outrasDespesas.despesa = [
                                _.cloneDeep(
                                    this.guias_visualizacao[index].mensagemTISS
                                        .prestadorParaOperadora.loteGuias
                                        .guiasTISS["guiaResumoInternacao"]
                                        .outrasDespesas.despesa
                                )
                            ];
                        }

                        var limiteDespesasResumo = _.cloneDeep(
                            _.orderBy(
                                this.guias_visualizacao[index].mensagemTISS
                                    .prestadorParaOperadora.loteGuias.guiasTISS[
                                    "guiaResumoInternacao"
                                ].outrasDespesas.despesa,
                                "descricaoProcedimento"
                            )
                        );

                        let arrayOutrasDespesas = [];

                        while (limiteDespesasResumo.length > 0) {
                            var restoDespesasResumo = limiteDespesasResumo.splice(10);

                            arrayOutrasDespesas.push(
                                _.cloneDeep(
                                    _.orderBy(
                                        limiteDespesasResumo,
                                        "descricaoProcedimento"
                                    )
                                )
                            );

                            limiteDespesasResumo = _.cloneDeep(restoDespesasResumo);
                        }

                        // Subistituir o array de outras despesas por um array de arrays
                        this.guias_visualizacao[
                            index
                        ].mensagemTISS.prestadorParaOperadora.loteGuias.guiasTISS[
                            "guiaResumoInternacao"
                        ].outrasDespesas.despesa = arrayOutrasDespesas;
                    }
                }
            }
        }
    },
    computed: {
        existeConsultaESadt: function() {
            return (
                this.marcacao_guias.find(
                    item =>
                        item.nome == "SP/SADT" ||
                        item.nome == "Honorário Individual"
                ) && this.marcacao_guias.find(item => item.nome == "Consulta")
            );
        }
    },
    props: ["guias", "marcacao", "logo_url", "nome_contratado_ass"],
    components: {
        GuiaDeConsulta,
        guiaSpsadt,
        guiaOutrasDespesas,
        GuiaHonorarios,
        ModalImpressao,
        guiaResumoInternacao,
        guiaOdonto
    }
};
</script>

<style></style>
